





















	import {Component, Prop} from "vue-property-decorator"
	import AbpBase from "@/lib/abpbase"
    import {QueryPatientEdu, QueryPatientEduModel,QueryPatientEduPlan } from "@/api/pdOutPatient/pdEducation/pdPatientEdu";
    import fileShow from "../pdKnowledge/fileShow.vue";
    import eduPreview from "../pdKnowledge/pdPreviousEducationPlay.vue";
import Title from "@/views/tool/sqlMaintain/title.vue";
	@Component({ components: { fileShow,eduPreview } })
	export default class AddPlan1 extends AbpBase {
		@Prop() value: boolean
		@Prop() data: any
		temps: any[] = []
		date = new Date()
        showPreview: boolean = false;
         previewData: any = {};
         eduPlanTime=new Date()
         Title="";
			columns = [
			{
				title: '宣教材料',
				key: 'knowledgeName',
			},
            {
            title: "操作",
            render:(h1:any, p:any)=>{
					const h = this.$createElement
            return h('div',[  h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small"
              },
              style: {
                marginRight: "10px"
              },
              on: {
                 click: () => {
                this.preview(p.row);
                },
              },
            },
            "预览"
          )
          ])
        }}
		]

		created() {
            console.log(this.data)
            this.Title=this.data.patientName+"的宣教材料";
            this.eduPlanTime=this.data.eduTime;
			this.getData()
		}

		private async getData() {
			this.getTemps()

		}

		async getTemps() {
			let res = await QueryPatientEduPlan(this.data)
			this.temps = res.objects
		}

		cancel() {
			this.$emit('input', false)
		}

		visibleChange(value: boolean) {
			if (!value) {
				this.$emit('input', value);
			}
		}
        viewData:any={};
        viewShow=false;
         preview(row: any) {
            this.viewData=row;
            this.viewShow = true;
        }
		selectedTableRow: any[] = [];
		tableSelectionChange(selection: any) {
			this.selectedTableRow = selection;
		}
	}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdOutPatient/pdEducation/pdPatientEducationBatch/showknowledge.vue